function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Deferred, noop } from "@sail/utils";
export const defaultExpireAfterMs = 60 * 1000;
class PrefetchCache {
    addItem(hash, pruningSignal) {
        const existingItem = this._items.get(hash);
        const existingDeferred = this._deferreds.get(hash);
        const prune = ()=>{
            pruningSignal === null || pruningSignal === void 0 ? void 0 : pruningSignal.removeEventListener('abort', prune);
            const item = this._items.get(hash);
            if (!item) {
                this._deferreds.delete(hash);
                return;
            }
            const selfIndex = item.queue.findIndex((el)=>el === prune);
            if (selfIndex === -1) {
                return;
            }
            item.queue.splice(selfIndex, 1);
            if (item.queue.length === 0) {
                this._items.delete(hash);
                if (item.result !== undefined) {
                    // Only remove the underlying deferred if the promise was resolved.
                    this._deferreds.delete(hash);
                }
            }
        };
        if (existingItem && existingDeferred) {
            existingItem.queue.push(prune);
            pruningSignal === null || pruningSignal === void 0 ? void 0 : pruningSignal.addEventListener('abort', prune);
            return existingItem;
        }
        const deferred = new Deferred();
        deferred.promise.catch(noop);
        const queue = [];
        queue.push(prune);
        const deferredItem = existingDeferred !== null && existingDeferred !== void 0 ? existingDeferred : {
            promise: deferred.promise,
            resolve: (result)=>{
                if (cacheItem.result !== undefined) {
                    return;
                }
                cacheItem.result = result;
                deferred.resolve(result);
                if (cacheItem.queue.length === 0) {
                    // If the queue is empty at the time the promise is resolved,
                    // we can remove the underlying deferred.
                    this._deferreds.delete(hash);
                }
                if (pruningSignal === null || pruningSignal === void 0 ? void 0 : pruningSignal.aborted) {
                    prune();
                } else {
                    pruningSignal === null || pruningSignal === void 0 ? void 0 : pruningSignal.addEventListener('abort', ()=>{
                        prune();
                    });
                }
                setTimeout(()=>{
                    // Unconditionally remove the item from the cache
                    // after the expiration time has passed, instead
                    // of simply calling `prune()` (i.e. popping an element
                    // out of the queue) to ensure possibly stale values
                    // don't live in the cache for too long.
                    this._items.delete(hash);
                    this._deferreds.delete(hash);
                }, this._expireAfterMs);
            },
            reject: (error)=>{
                deferred.reject(error);
                this._items.delete(hash);
                this._deferreds.delete(hash);
            }
        };
        const cacheItem = {
            promise: deferredItem.promise,
            result: undefined,
            queue
        };
        this._items.set(hash, cacheItem);
        this._deferreds.set(hash, deferredItem);
        return cacheItem;
    }
    resolve(hash, result) {
        var _this__deferreds_get;
        return (_this__deferreds_get = this._deferreds.get(hash)) === null || _this__deferreds_get === void 0 ? void 0 : _this__deferreds_get.resolve(result);
    }
    reject(hash, error) {
        var _this__deferreds_get;
        return (_this__deferreds_get = this._deferreds.get(hash)) === null || _this__deferreds_get === void 0 ? void 0 : _this__deferreds_get.reject(error);
    }
    getItem(hash) {
        const existingItem = this._items.get(hash);
        if (!existingItem) {
            return undefined;
        }
        const pruneFn = existingItem.queue[0];
        pruneFn === null || pruneFn === void 0 ? void 0 : pruneFn();
        var _existingItem_result;
        return (_existingItem_result = existingItem.result) !== null && _existingItem_result !== void 0 ? _existingItem_result : existingItem.promise;
    }
    clear() {
        this._items.clear();
    }
    constructor(options){
        _define_property(this, "_items", new Map());
        _define_property(this, "_deferreds", new Map());
        _define_property(this, "_expireAfterMs", void 0);
        var _options_expireAfterMs;
        this._expireAfterMs = (_options_expireAfterMs = options === null || options === void 0 ? void 0 : options.expireAfterMs) !== null && _options_expireAfterMs !== void 0 ? _options_expireAfterMs : defaultExpireAfterMs;
    }
}
export { PrefetchCache as default };

//# sourceMappingURL=PrefetchCache.js.map